<template>
  <div class="factoryTools">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="SAP工单" name="first">
          <span class="childTabs" @click="cutViewChange('order')" :class="{ activeLink: !cutView || cutView=='order' }">生产工单</span>
          <span class="childTabs" @click="cutViewChange('shipment')" :class="{ activeLink: cutView=='shipment' }">交货单</span>
          <span class="childTabs" @click="cutViewChange('shipmentOrderItemRecord')" :class="{ activeLink: cutView=='shipmentOrderItemRecord' }">发货记录</span>
          <span class="childTabs" @click="cutViewChange('export')" :class="{ activeLink: cutView=='export' }">报工记录</span>
          <span class="childTabs" @click="cutViewChange('report')" :class="{ activeLink: cutView=='report' }">报工统计表</span>
          <span class="childTabs" @click="cutViewChange('storage')" :class="{ activeLink: cutView=='storage' }">入库记录</span>
          <span class="childTabs" @click="cutViewChange('repair')" :class="{ activeLink: cutView=='repair' }">维修统计表</span>
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
            </div>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button> -->
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button v-if="cutView=='export' || cutView=='report' || cutView=='storage' || cutView=='repair'" type="primary" icon="el-icon-download" size="small" @click="exportProcess">导出</el-button>
              <el-button v-if="cutView=='shipmentOrderItemRecord'" type="primary" size="small" @click="batchBack">退货</el-button>
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button class="btn_more" :class="{ activeUserMore: isMoreSearch }" size="small" icon="el-icon-d-arrow-right" @click="moreSearchBtn"></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>     
        <el-tab-pane v-for="(item, index) in tabPaneList" :key="item.id" :label="item.aufnr" :name="item.id">
          <span slot="label">
            {{ item.aufnr }}
            <i class="el-icon-circle-close" @click.stop="closeTabPane(index)"></i>
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')">
            工单详情
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'itemList' }"
            @click="cutDetailChange('itemList')">
            物料清单
            <div class="btnBox" v-if="cutDetail == 'itemList'">
              <el-tooltip class="item" content="打印物料清单" placement="bottom" :open-delay="300">
                <el-button type="primary" size="small" @click.stop="onPrintItem(orderStatus)">打印</el-button>
              </el-tooltip>
            </div>
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'grnList' }"
            @click="cutDetailChange('grnList')">
            LPN投料记录
            <div class="btnBox" v-if="cutDetail == 'grnList'">
              <el-tooltip class="item" content="LPN投料" placement="bottom" :open-delay="300">
                <el-button type="primary" size="small" @click.stop="onFeedGrn(orderStatus)">投料</el-button>
              </el-tooltip>
            </div>
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'process' }"
            @click="cutDetailChange('process')">
            工序和报工
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'storage' }"
            @click="cutDetailChange('storage')">
            入库记录
            <div class="btnBox" v-if="cutDetail == 'storage'">
              <el-tooltip class="item" content="打印入库送货单" placement="bottom" :open-delay="300">
                <el-button  size="small" @click="onPrintStorage(orderStatus)">打印</el-button>
              </el-tooltip>
              <el-tooltip class="item" content="成品入库" placement="bottom" :open-delay="300">
                <el-button type="primary" size="small" @click.stop="onStorage(orderStatus)">入库</el-button>
              </el-tooltip>
            </div>
          </span>
        </el-tab-pane>
        <el-tab-pane v-for="(item, index) in tabPaneList2" :key="item.id" :label="item.likpVbeln" :name="item.id">
          <span slot="label">
            {{ item.likpVbeln }}
            <i class="el-icon-circle-close" @click.stop="closeTabPane2(index)"></i>
          </span>
          <span class="childTabs" :class="{ activeLink: cutDetail == 'shipmentDetail' }"
            @click="cutDetailChange('shipmentDetail')">
            交货单详情
          </span>
        </el-tab-pane>
      </el-tabs>
      <!-- 查询条件 -->
      <el-form v-if="tabPaneValue == 'first' && isMoreSearch"
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox" v-if="cutView=='order'">
          <el-form-item label="工单号" size="small">
            <el-input v-model="searchConditionForm.aufnr" placeholder="工单号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工厂型号" size="small">
            <el-input v-model="searchConditionForm.model" placeholder="工厂型号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="产品物料" size="small">
            <el-input v-model="searchConditionForm.matnr" placeholder="产品物料" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工厂代码" size="small">
            <el-input v-model="searchConditionForm.werks" placeholder="工厂代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工单类型" size="small">
            <el-input v-model="searchConditionForm.auart" placeholder="工单类型" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-input v-model="searchConditionForm.kdauf" placeholder="销售订单" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="客户代码" size="small">
            <el-input v-model="searchConditionForm.kunnr" placeholder="客户代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="业务员" size="small">
            <el-input v-model="searchConditionForm.ktonr" placeholder="业务员" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工单状态" size="small">
            <el-input v-model="searchConditionForm.txt04" placeholder="工单状态" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='shipment'">
          <el-form-item label="交货单号" size="small">
            <el-input v-model="searchConditionForm.likpVbeln" placeholder="交货单号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="客户名称" size="small">
            <el-input v-model="searchConditionForm.adrcName1" placeholder="客户名称" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="销售组织" size="small">
            <el-input v-model="searchConditionForm.likpVkorg" placeholder="销售组织" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="装运点" size="small">
            <el-input v-model="searchConditionForm.likpVstel" placeholder="装运点" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='shipmentOrderItemRecord'">
          <el-form-item label="交货单号" size="small">
            <el-input v-model="searchConditionForm.likpVbeln" placeholder="交货单号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="客户名称" size="small">
            <el-input v-model="searchConditionForm.adrcName1" placeholder="客户名称" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-input v-model="searchConditionForm.lipsVgbel" placeholder="销售订单" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-input v-model="searchConditionForm.zc0011" placeholder="产品型号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="SN" size="small">
            <el-input v-model="searchConditionForm.sn" placeholder="SN" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='export'">
          <el-form-item label="工单号" size="small">
            <el-input v-model="searchConditionForm.aufnr" placeholder="工单号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工作中心" size="small">
            <el-input v-model="searchConditionForm.arbpl" placeholder="工作中心名称" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDate"
              type="date"
              placeholder="报工时间"
              value-format="yyyy-MM-dd"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDate"
              type="date"
              placeholder="报工时间"
              @change="endDateChange"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="报工人" size="small">
            <el-input v-model="searchConditionForm.user" placeholder="报工人" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='report'">
          <el-form-item label="报工月份" size="small">
            <el-date-picker v-model="searchConditionForm.month" type="month" value-format="yyyy-MM" placeholder="选择月"></el-date-picker>
          </el-form-item>
          <el-form-item label="工厂名称" size="small">            
            <el-input v-model="searchConditionForm.werks" placeholder="工厂名称" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工单号" size="small">            
            <el-input v-model="searchConditionForm.aufnr" placeholder="工单号" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工作中心" size="small">            
            <el-input v-model="searchConditionForm.arbpl" placeholder="工作中心" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="线别" size="small">            
            <el-input v-model="searchConditionForm.ktext" placeholder="线别" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="拉长" size="small">            
            <el-input v-model="searchConditionForm.employeeName" placeholder="拉长" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>          
          <el-form-item label="是否加班" size="small">
            <el-select v-model="searchConditionForm.overtime"
              placeholder="选择是否加班加班工时" filterable clearable>
              <el-option label="正常工时" :value="false"></el-option>
              <el-option label="加班工时" :value="true"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='repair'">
          <el-form-item label="月份" size="small">
            <el-date-picker v-model="searchConditionForm.month" type="month" value-format="yyyy-MM" placeholder="送修或维修月份"></el-date-picker>
          </el-form-item>
          <el-form-item label="加工工厂" size="small">            
            <el-input v-model="searchConditionForm.werks" placeholder="加工工厂" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="销售订单" size="small">            
            <el-input v-model="searchConditionForm.arbpl" placeholder="销售订单" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="生产工单" size="small">            
            <el-input v-model="searchConditionForm.aufnr" placeholder="生产工单" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="SN" size="small">            
            <el-input v-model="searchConditionForm.ktext" placeholder="SN" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="人员" size="small">            
            <el-input v-model="searchConditionForm.employeeName" placeholder="送修员或维修员" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="cutView=='storage'">
          <el-form-item label="SAP单号" size="small">
            <el-input v-model="searchConditionForm.sapOrderNumber" placeholder="SAP单号" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="入库凭证" size="small">
            <el-input v-model="searchConditionForm.mblnr" placeholder="入库凭证号" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="物料编码" size="small">
            <el-input v-model="searchConditionForm.matnr" placeholder="物料编码" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="入库单号" size="small">
            <el-input v-model="searchConditionForm.xblnr" placeholder="入库单号" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="批次号" size="small">
            <el-input v-model="searchConditionForm.charg" placeholder="批次号" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="工厂" size="small">
            <el-input v-model="searchConditionForm.werks" placeholder="收货工厂" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="库存地点" size="small">
            <el-input v-model="searchConditionForm.lgort" placeholder="库存地点" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="移动类型" size="small">
            <el-input v-model="searchConditionForm.bwart" placeholder="移动类型" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDate"
              type="date"
              placeholder="过账日期"
              value-format="yyyy-MM-dd"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDate"
              type="date"
              placeholder="过账日期"
              @change="endDateChange"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="入库员" size="small">
            <el-input v-model="searchConditionForm.user" placeholder="入库员" clearable @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
      </el-form>
      <!-- 温馨提示 -->
      <div
        class="tips tipsBox"
        v-show="isMoreSearch && cutView=='order'"
      >
        <span class="title">温馨提示：</span>
        <span class="text">
          默认只查询当前当前登录用户对应工厂工单，查询其他工厂请输入具体工厂代码。
        </span>
      </div>
    </div>
    <!-- SAP工单列表 -->
    <div class="contentBox">
      <div v-if="tabPaneValue == 'first'" class="rightContent">
        <el-table v-if="!cutView || cutView=='order'" stripe border style="width: 100%" height="100%" size="mini"
          :data="tableData" @sort-change="sortChange"
        >
          <el-table-column type="index" align="center"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column width="120px" 
            label="工单号" align="center" prop="aufnr" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">
                {{ scope.row.aufnr }}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="80px"
            label="产品型号" prop="model" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>
                {{ scope.row.model ? scope.row.model : "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="110px" 
            label="产品物料" prop="originalOrder" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.maktx" :content="scope.row.maktx" class="item" effect="dark" placement="top" :open-delay="300">
                <span>
                  {{scope.row.matnr ? scope.row.matnr : '-'}}
                </span>
              </el-tooltip>
              <span v-else>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="中类" prop="originalOrder" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>
                {{scope.row.productType ? scope.row.productType : '-'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column width="80px" 
            label="工厂代码" prop="werks" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.wektx" :content="scope.row.wektx" class="item" effect="dark" placement="top" :open-delay="300">
                <span>
                  {{scope.row.werks ? scope.row.werks : '-'}}
                </span>
              </el-tooltip>
              <span v-else>{{scope.row.werks ? scope.row.werks : '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column width="80px" 
            label="工单类型" prop="auart" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.auart">
                {{ scope.row.auart }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column width="80px" 
            label="工单数量" prop="psmng" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.psmng">
                {{ scope.row.psmng }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column width="80px" 
            label="入库数量" prop="wemng" align="center" show-overflow>
            <template slot-scope="scope">
              <span v-if="scope.row.wemng">
                {{ scope.row.wemng }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="销售订单" prop="kdauf" align="center" show-overflow-tooltip width="110px">
            <template slot-scope="scope">
              <span>
                {{ scope.row.kdauf ? scope.row.kdauf : "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column min-width="55px" 
            label="客户代码" prop="kunnr" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.vkorg?scope.row.vkorg : '(查询失败)'" class="item" effect="dark" placement="top" :open-delay="300">
                <span>
                  {{scope.row.kunnr ? scope.row.kunnr : '-'}}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column min-width="50px" show-overflow-tooltip
            label="业务员" prop="ktonr" align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.ktonr ? scope.row.ktonr.replace(/(\s)/, '$1(')+")" : "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="工单状态" prop="txt04" align="center" show-overflow-tooltip width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.txt04">
                {{ scope.row.txt04 }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <shipmentOrderPage
          ref="shipmentOrderPage"
          :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.shipment" :searchConditionForm="searchConditionForm"
        ></shipmentOrderPage>
        <processExportPage
          ref="processExportPage"
          :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.export" :searchConditionForm="searchConditionForm"
        ></processExportPage>
        <shipmentOrderItemRecordPage
          ref="shipmentOrderItemRecordPage"
          :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.shipmentOrderItemRecord" :searchConditionForm="searchConditionForm"
          ></shipmentOrderItemRecordPage>
        <reportPage ref="reportPage"
        :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.report" :searchConditionForm="searchConditionForm"
        ></reportPage>
        <storageExportPage ref="storageExportPage"
        :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.storage" :searchConditionForm="searchConditionForm"
        ></storageExportPage>
        <repairPage ref="repairPage"
        :tabPaneValue="tabPaneValue" :cutView="cutView" :pagination="pagination.repair" :searchConditionForm="searchConditionForm"
        ></repairPage>
        <pagination
          v-if="!cutView || cutView=='order'"
          :pagination="pagination.order"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='shipment'"
          :pagination="pagination.shipment"
          @currentChange="shipmentCurrentChange"
          @sizeChange="shipmentSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='shipmentOrderItemRecord'"
          :pagination="pagination.shipmentOrderItemRecord"
          @currentChange="shipmentOrderItemCurrentChange"
          @sizeChange="shipmentOrderItemSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='export'"
          :pagination="pagination.export"
          @currentChange="exportCurrentChange"
          @sizeChange="exportSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='report'"
          :pagination="pagination.report"
          @currentChange="reportCurrentChange"
          @sizeChange="reportSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='storage'"
          :pagination="pagination.storage"
          @currentChange="storageCurrentChange"
          @sizeChange="storageSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
        <pagination
          v-else-if="cutView=='repair'"
          :pagination="pagination.repair"
          @currentChange="repairCurrentChange"
          @sizeChange="repairSizeChange"
          @refreshBtn="getSapOrderSearch"
        ></pagination>
      </div>   
      <div class="rightContent" v-else>
        <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <processPage
          ref="processPage"
          v-else-if="cutDetail == 'process'"
          :tabPaneValue="tabPaneValue" :tabPaneData="tabPaneData"
        ></processPage>
        <itemPage
          ref="itemPage"
          v-else-if="cutDetail == 'itemList'"
          :tabPaneValue="tabPaneValue"
        ></itemPage>
        <grnPage
          ref="grnPage"
          v-else-if="cutDetail == 'grnList'"
          :tabPaneValue="tabPaneValue"
        ></grnPage>
        <storagePage
          ref="storagePage"
          v-else-if="cutDetail == 'storage'"
          :tabPaneValue="tabPaneValue"
        ></storagePage>
        <shipmentDetailPage
          ref="shipmentDetailPage"
          v-else-if="cutDetail == 'shipmentDetail'"
          :tabPaneValue="tabPaneValue"
        ></shipmentDetailPage>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import detailPage from "./components/detailPage.vue";
import itemPage from "./components/itemPage.vue";
import grnPage from "./components/grnPage.vue";
import storagePage from "./components/storagePage.vue";
import shipmentOrderPage from "./components/shipmentOrderPage.vue";
import processExportPage from "./components/processExportPage.vue";
import shipmentDetailPage from "./components/shipmentDetailPage.vue";
import shipmentOrderItemRecordPage from "./components/shipmentOrderItemRecordPage.vue";
import reportPage from "./components/reportPage.vue";
import storageExportPage from "./components/storageExportPage.vue";
import repairPage from "./components/repairPage.vue";
import processPage from "./components/processPage.vue";
import {apiRepairRecordExport} from "@/api/repair.js";
import {
  apiSapOrderReportedSearch2
} from "@/api/SapOrder.js";
import {
  apiSapOrderSearch,
  apiSapReportedExport,
  apiSapStorageExport
} from "@/api/SapOrder.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/sap", subTabs: { cutView: ["order", "shipment", "shipmentOrderItemRecord", "export", "report", "storage", "repair"] } },
  components: {
    pagination,
    detailPage,
    processPage,
    itemPage,
    grnPage,
    storagePage,
    shipmentOrderPage,
    shipmentDetailPage,
    processExportPage,
    shipmentOrderItemRecordPage,
    reportPage,
    storageExportPage,
    repairPage
  },
  data() {
    return {
      cutView: "order",
      tabPaneValue: "first",
      settingType: "table",
      isMoreSearch: false,
      tabPaneList: [],
      tabPaneList2: [],
      tabPaneData: {},
      searchConditionForm: {},
      pullDownData: {
        customerList:[],
      },
      orderStatus : null,
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        order: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        shipment: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        shipmentOrderItemRecord: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        export: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        report: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        storage: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
        repair: {
          currentPage: 1,
          pageSize: 40,
          total: 102,
          beginIndex: 1,
          endIndex: 10,
        },
      },
      cutDetail: "detail",
      dialogTitle: "",
      dialogForm: {
        productionOrder:{},
        createUser:{},
      },
      dialogRules: {
        
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.$nextTick(() => {
          if (this.cutView=='order') {
            this.getSapOrderSearch();
          } else if(this.cutView=='shipment') {
            this.$refs.shipmentOrderPage.onSearch(this.searchConditionForm);
          } else if(this.cutView=='shipmentOrderItemRecord') {
            this.$refs.shipmentOrderItemRecordPage.onSearch(this.searchConditionForm);
          } else if(this.cutView=='reportPage') {
            this.$refs.reportPage.onSearch(this.searchConditionForm);
          } else if(this.cutView=='repairPage') {
            this.$refs.repairPage.onSearch(this.searchConditionForm);
          } else  if(this.cutView=='export') {
            this.$refs.processExportPage.onSearch(this.searchConditionForm);
          } else {            
            this.$message({
              type: "error",
              message: `错误的页面名称【+this.cutView+】！`,
            });
          }
        });
      } else {
        this.$nextTick(() => {
          this.tabPaneData=null;
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          if (this.tabPaneData==null) {
            this.tabPaneList2.forEach((item) => {
              if (item.id == newVal) {
                this.tabPaneData = item;
              }
            });
            if (this.tabPaneData!=null) {
              this.cutDetail = "shipmentDetail";
            }
          } else {            
            this.cutDetail = "detail";
          }
          if (this.cutDetail == "detail") {
            setTimeout(() => {
              this.$refs.detailPage.detail();
            }, 100);
          } else if (this.cutDetail == "process") {
            this.$refs.processPage.onSearch();
          } else if (this.cutDetail == "itemList") {
            this.$refs.itemPage.onSearch();
          } else if (this.cutDetail == "grnList") {
            this.$refs.grnPage.onSearch();
          } else if (this.cutDetail == "storage") {
            this.$refs.storagePage.onSearch();
          } else if (this.cutDetail == "shipmentDetail") {
            setTimeout(() => {
              this.$refs.shipmentDetailPage.detail();
            }, 100);
          }
        });
      }
    }    
  },
  methods: {
    onStorage(orderStatus) {
      if (!orderStatus) {
        this.$message({
          type: "error",
          message: `当前工单状态为NULL，请联系AIM管理员处理！`,
        });
      } else if(orderStatus!='REL') {
        this.$message({
          type: "error",
          message: `当前工单状态错误【`+ orderStatus +`】不能入库，请联系PMC处理！`,
        });
      } else {
        this.$refs.storagePage.onStorage();
      }
    },
    onPrintItem(orderStatus) {
      if (!orderStatus) {
        this.$message({
          type: "error",
          message: `当前工单状态为NULL，请联系AIM管理员处理！`,
        });
      } else if(orderStatus!='REL') {
        this.$message({
          type: "error",
          message: `当前工单状态错误【`+ orderStatus +`】不能打印物料清单，请联系PMC处理！`,
        });
      } else {
        this.$refs.itemPage.onPrintItem();
      }
    },
    onFeedGrn(orderStatus) {
      if (!orderStatus) {
        this.$message({
          type: "error",
          message: `当前工单状态为NULL，请联系AIM管理员处理！`,
        });
      } else if(orderStatus!='REL') {
        this.$message({
          type: "error",
          message: `当前工单状态错误【`+ orderStatus +`】不能投料生产，请联系PMC处理！`,
        });
      } else {
        this.$refs.grnPage.onFeedGrn();
      }
    },
    onPrintStorage(orderStatus) {
      if (!orderStatus) {
        this.$message({
          type: "error",
          message: `当前工单状态为NULL，请联系AIM管理员处理！`,
        });
      } else if(orderStatus!='REL') {
        this.$message({
          type: "error",
          message: `当前工单状态错误【`+ orderStatus +`】不能打印入库单，请联系PMC处理！`,
        });
      } else {
        this.$refs.storagePage.onPrintStorage();
      }
    },

    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    closeTabPane2(index) {
      if (this.tabPaneList2[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList2[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList2.splice(index, 1);
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.detail();
        } else if (value == "process") {
          this.$refs.processPage.onSearch();
        } else if (value == "itemList") {
          this.$refs.itemPage.onSearch();
        } else if (value == "grnList") {
          this.$refs.grnPage.onSearch();
        } else if (value == "storage") {
          this.$refs.storagePage.onSearch();
        } else if (value == "shipment") {
          this.$refs.shipmentOrderPage.onSearch();
        } else if (value == "shipmentOrderItemRecord") {
          this.$refs.shipmentOrderItemRecordPage.onSearch();
        } else if (value == "production") {
          this.onSearch();
        } else if(value=='report') {
          this.$refs.reportPage.onSearch();
        } else if(value=='storage') {
          this.$refs.storageExportPage.onSearch();
        } else if(value=='repair') {
          this.$refs.repairPage.onSearch();
        }
      });
      this.$moreSearchStyle();
    },
    cutViewChange(value) {
      this.cutView = value;
      if (value=="order") {
        this.onSearch();
      } else if(value=="shipment"){
        this.$refs.shipmentOrderPage.onSearch();
      } else if(value=="shipmentOrderItemRecord"){
        this.$refs.shipmentOrderItemRecordPage.onSearch();
      } else if(value=="report"){
        this.$refs.reportPage.onSearch();
      } else if(value=="storage"){
        this.$refs.storageExportPage.onSearch();
      } else if(value=="repair"){
        this.$refs.repairPage.onSearch();
      } else if(value=="process") {
        this.$refs.processExportPage.onSearch();
      } else if(value=="export") {
        this.$refs.processExportPage.onSearch();
      } else {        
        this.$message({
          type: "error",
          message: `错误的页面名称【`+ value +`】！`,
        });
        return;
      }
      this.$moreSearchStyle();
    },
    // 点击表格编号
    clickAllowSkip(row) {
      this.cutDetail="detail";
      this.nowRowData = row;
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 表格数据
    async getSapOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      var res = null;
      if (this.cutView=='order') { 
        res = await apiSapOrderSearch({
          ...this.searchConditionForm,
          pageNum: this.pagination.order.currentPage,
          pageSize: this.pagination.order.pageSize,
          desc: this.desc,
          orderBy: this.orderBy,
        });
        // console.log(res);
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.order.total = res.total;
          this.pagination.order.beginIndex = res.beginIndex;
          this.pagination.order.endIndex = res.endIndex;        
        }
      } else if(this.cutView=='shipment') {
        this.$refs.shipmentOrderPage.onSearch();
      }else if(this.cutView=='shipmentOrderItemRecord') {
        this.$refs.shipmentOrderItemRecordPage.onSearch();
      } else if(this.cutView=='export') {
        this.$refs.processExportPage.onSearch();
      } else if(this.cutView=='report') {
        this.$refs.reportPage.onSearch();
      } else if(this.cutView=='storage') {
        this.$refs.storageExportPage.onSearch();
      } else if(this.cutView=='repair') {
        this.$refs.repairPage.onSearch();
      } else {
        this.$message({
          type: "error",
          message: `不能识别标签类别！`,
        });
        return;
      }
      if (callback) callback();
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {      
      this.searchConditionForm = {};
      this.$refs.shipmentOrderPage.searchConditionForm=this.searchConditionForm;
      this.$refs.shipmentOrderItemRecordPage.searchConditionForm=this.searchConditionForm;
      this.$refs.processExportPage.searchConditionForm=this.searchConditionForm;
      this.$refs.reportPage.searchConditionForm=this.searchConditionForm;
      this.$refs.storageExportPage.searchConditionForm=this.searchConditionForm;
      this.$refs.repairPage.searchConditionForm=this.searchConditionForm;
      if (this.cutView=='order') {
        this.pagination.order.currentPage = 1;
      } else if(this.cutView=='shipment') {
        this.pagination.shipment.currentPage = 1;
      } else if(this.cutView=='shipmentOrderItemRecord') {
        this.pagination.shipmentOrderItemRecord.currentPage = 1;
      } else if(this.cutView=='report') {
        this.pagination.report.currentPage = 1;
      } else if(this.cutView=='repair') {
        this.pagination.repair.currentPage = 1;
      } else if(this.cutView=='export') {
        this.pagination.export.currentPage = 1;
      } else if(this.cutView=='storage') {
        this.pagination.storage.currentPage = 1;
      } else if(this.cutView=='repair') {
        this.$message({
          type: "error",
          message: `不能识别标签类别！`,
        });
        return;
      }
      this.onSearch();
    },    
    exportProcess() {
      this.$confirm(`请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res;
        if (this.cutView=='export') {
          res =await apiSapReportedExport({
            ...this.searchConditionForm,
            export: true,
          });
        } else if (this.cutView=='report') {
          if (!this.searchConditionForm.month) {
            this.$message({
              type: "error",
              message: `请选择要导出的月份！`,
            });
            return;
          }
          res =await apiSapOrderReportedSearch2({
            ...this.searchConditionForm,
            export: true,
          });
        } else if (this.cutView=='repair') {
          if (!this.searchConditionForm.month) {
            this.$message({
              type: "error",
              message: `请选择要导出的月份！`,
            });
            return;
          }
          res =await apiRepairRecordExport({
            ...this.searchConditionForm,
            export: true,
          });
        } else if (this.cutView=='storage') {
          res =await apiSapStorageExport({
            ...this.searchConditionForm,
            export: true,
          });
        }
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      })
    },
    batchBack() {
      this.$refs.shipmentOrderItemRecordPage.batchBack();
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        if (this.cutView=='order') {
          this.pagination.currentPage = 1;
        } else if(this.cutView=='shipment') {
          this.$refs.shipmentOrderPage.pagination.currentPage = 1;
        } else if(this.cutView=='shipmentOrderItemRecord') {
          this.$refs.shipmentOrderItemRecordPage.pagination.currentPage = 1;
        } else if(this.cutView=='report') {
          this.$refs.reportPage.pagination.currentPage = 1;
        } else if(this.cutView=='storage') {
          this.$refs.storageExportPage.pagination.currentPage = 1;
        } else if(this.cutView=='repair') {
          this.$refs.repairPage.pagination.currentPage = 1;
        } else if(this.cutView=='export'){
          this.$refs.processExportPage.pagination.currentPage = 1;
        } else {
          this.$message({
            type: "error",
            message: `不能识别标签类别！`,
          });
          return;
        }
        this.getSapOrderSearch();
      } else if (this.tabPaneValue == "process") {
        this.$refs.processPage.onSearch();
      } else if (this.tabPaneValue == "itemList") {
        this.$refs.itemPage.onSearch();
      } else if (this.tabPaneValue == "grnList") {
        this.$refs.grnPage.onSearch();
      } else if (this.tabPaneValue == "storage") {
        this.$refs.storagePage.onSearch();
      } else if (this.tabPaneValue == "report") {
        this.$refs.reportPage.onSearch();
      } else if (this.tabPaneValue == "repair") {
        this.$refs.repairPage.onSearch();
      } else if(this.tabPaneValue=='export'){
        this.$refs.processExportPage.onSearch();
      } else {
        this.$message({
          type: "error",
          message: `不能识别标签类别！`,
        });
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.order.currentPage = val;
      this.getSapOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.order.currentPage = 1;
      this.pagination.order.pageSize = val;
      this.getSapOrderSearch();
    },
    // 交货单分页
    shipmentCurrentChange(val) {
      this.pagination.shipment.currentPage = val;
      this.$refs.shipmentOrderPage.onSearch();
    },
    shipmentSizeChange(val) {
      this.pagination.shipment.currentPage = 1;
      this.pagination.shipment.pageSize = val;
      this.$refs.shipmentOrderPage.onSearch();
    },
    // 发货记录分页
    shipmentOrderItemCurrentChange(val) {
      this.pagination.shipmentOrderItemRecord.currentPage = val;
      this.$refs.shipmentOrderItemRecordPage.onSearch();
    },
    shipmentOrderItemSizeChange(val) {
      this.pagination.shipmentOrderItemRecord.currentPage = 1;
      this.pagination.shipmentOrderItemRecord.pageSize = val;
      this.$refs.shipmentOrderItemRecordPage.onSearch();
    },
    // 报工记录分页
    exportCurrentChange(val) {
      this.pagination.export.currentPage = val;
      this.$refs.processExportPage.onSearch();
    },
    exportSizeChange(val) {
      this.pagination.export.currentPage = 1;
      this.pagination.export.pageSize = val;
      this.$refs.processExportPage.onSearch();
    },
    // 报工统计表分页
    reportCurrentChange(val) {
      this.pagination.report.currentPage = val;
      this.$refs.reportPage.onSearch();
    },
    reportSizeChange(val) {
      this.pagination.report.currentPage = 1;
      this.pagination.report.pageSize = val;
      this.$refs.reportPage.onSearch();
    },
    // 入库记录分页
    storageCurrentChange(val) {
      this.pagination.storage.currentPage = val;
      this.$refs.storageExportPage.onSearch();
    },
    storageSizeChange(val) {
      this.pagination.storage.currentPage = 1;
      this.pagination.storage.pageSize = val;
      this.$refs.storageExportPage.onSearch();
    },
    // 维修统计表分页
    repairCurrentChange(val) {
      this.pagination.repair.currentPage = val;
      this.$refs.repairPage.onSearch();
    },
    repairSizeChange(val) {
      this.pagination.repair.currentPage = 1;
      this.pagination.repair.pageSize = val;
      this.$refs.repairPage.onSearch();
    },    
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getSapOrderSearch();
    }
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getSapOrderSearch("", this.callback);
    } else {
      if (this.cutDetail == "detail") {
         this.$refs.detailPage.detail();
      } else if (this.tabPaneValue == "process") {
        this.$refs.processPage.onSearch();
      } else if (this.tabPaneValue == "itemList") {
        this.$refs.itemPage.onSearch();
      } else if (this.tabPaneValue == "grnList") {
        this.$refs.grnPage.onSearch();
      } else if (this.tabPaneValue == "storage") {
        this.$refs.storagePage.onSearch();
      }
    }
  },
  deactivated() {
    window.onresize = null;
  }
};
</script>
<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}

  .fail {
    color: #f56c6c;
  }
  .tiaojian {
    color: #e6a23c;
  }
  .pass_{
    color:#67C23A;
  }
</style>